import {Id} from "./scenes-interfaces";
import {IPrivilege, IPrivileges} from "./enterprise-interface";

export enum EnumIEnterprisePrivilegesCommand {
    REMOVE_PRIVILEGES,
    UPDATE_PRIVILEGES_NAME,
    UPDATE_PRIVILEGES_ATTRIBUTES,
    UPDATE_PRIVILEGES_VALUES
}

export enum EnumIEnterpriseBusinessCommand {
    USER_ADD,
    USER_RENAME,
    USER_UPDATE_ACCESS,
    USER_REMOVE,
    USER_UPDATE_ACCESS_PASSWORD,
    USER_CREATE_ACCOUNT_EMPTY,
    USER_CREATE_ACCOUNT_SAMPLE,
    USER_CREATE_ACCOUNT_IMPORT,
    USER_ACCOUNT,
    OPEN_ADVANCED,
}



export interface IEnterpriseBusinessUsers {
    BusinessUsers: Array<IEnterpriseBusinessUser>;
}

export interface IEnterpriseApps {
    id: string;
    installed: string;
}


export interface IEnterpriseBusinessUser {
    $: {
        name: string;
        privilegeId: string;
        accessMask: number;
        businessId: string;
    };
}

export interface IEnterpriseBusinessUserUpdate {
    businessId: Id;
    command: EnumIEnterpriseBusinessCommand;
    name1?: string;
    name2?: string;
    password?: string;
    computedAccessMask?: number;
    privilegeId?;
}

export interface IEnterprisePrivilegesUpdate {
    command?: EnumIEnterprisePrivilegesCommand;
    businessId?: Id;
    privilegeId?;
    privilegeDefaultId?;
    privilegeData?: IPrivileges;
    selPrivName?;
    tableName?;
    privelegesAttribute?;
    attr?;
    index?;
    privItemKey?: string;
    privModeEnum?;
    updTotalBits?;
}

export interface IEnterpriseBusinessAddUser {
    businessId: Id;
    computedAccessMask?: number;
    privilegeId?;
}
